import React from "react";
import { useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const Pages = ({ control }) => {
  const { availablePages, locationalOverviewReportMetrics } = useSelector(
    (state) => state.organizations.commonSettings
  );

  return (
    <>
      <div className="admin-organizations__section">
        <div className="admin-organizations__dropdown">
          <p>Select available pages</p>
          <Controller
            control={control}
            name="available_pages"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  valueKey="name"
                  height={275}
                  haveOnSelectChange
                  includeSelectAll
                  enableOnly
                  options={availablePages}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>

        <div className="admin-organizations__dropdown">
          <p>Multi location overview reports</p>
          <Controller
            control={control}
            name="locational_overview_report_metrics"
            render={({ field: { onChange, value } }) => {
              return (
                <Dropdown
                  height={275}
                  haveOnSelectChange
                  includeSelectAll
                  enableOnly
                  options={locationalOverviewReportMetrics}
                  selectedFilters={value ?? []}
                  numberDisplayed={0}
                  onSelectChange={(data) => onChange(data)}
                />
              );
            }}
          />
        </div>
      </div>
    </>
  );
};
